"use client";

import * as React from "react";
import Link from "next/link";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Menu } from "lucide-react";

interface MobileNavProps {
  isAuthenticated: boolean;
  isAdmin?: boolean;
}

export function MobileNav({ isAuthenticated, isAdmin }: MobileNavProps) {
  const formRef = React.useRef<HTMLFormElement | null>(null);

  return (
    <div className="md:hidden">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button
            aria-label="Open navigation menu"
            className="inline-flex items-center justify-center rounded-md border border-border/70 bg-background p-2 text-foreground shadow-sm hover:border-primary/50"
          >
            <Menu className="h-5 w-5" />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content
          sideOffset={8}
          align="end"
          className="z-50 min-w-[220px] rounded-md border border-border/70 bg-background p-1 text-sm shadow-md"
        >
          {isAuthenticated ? (
            <DropdownMenu.Item asChild>
              <Link href="/dashboard" className="block cursor-pointer rounded px-2 py-1.5 text-foreground hover:bg-muted">
                Dashboard
              </Link>
            </DropdownMenu.Item>
          ) : null}
          <DropdownMenu.Item asChild>
            <Link href="/courses" className="block cursor-pointer rounded px-2 py-1.5 text-foreground hover:bg-muted">
              Courses
            </Link>
          </DropdownMenu.Item>
          <DropdownMenu.Item asChild>
            <Link href="/right-now" className="block cursor-pointer rounded px-2 py-1.5 text-foreground hover:bg-muted">
              Right Now
            </Link>
          </DropdownMenu.Item>
          <DropdownMenu.Item asChild>
            <Link href="/next-gen" className="block cursor-pointer rounded px-2 py-1.5 text-foreground hover:bg-muted">
              Next Gen
            </Link>
          </DropdownMenu.Item>
          {isAdmin ? (
            <DropdownMenu.Item asChild>
              <Link href="/admin" className="block cursor-pointer rounded px-2 py-1.5 text-foreground hover:bg-muted">
                Admin
              </Link>
            </DropdownMenu.Item>
          ) : null}
          <DropdownMenu.Separator className="my-1 h-px bg-border/70" />
          {isAuthenticated ? (
            <DropdownMenu.Item
              className="block cursor-pointer rounded px-2 py-1.5 text-foreground hover:bg-muted"
              onSelect={(e) => {
                e.preventDefault();
                formRef.current?.requestSubmit();
              }}
            >
              Sign out
            </DropdownMenu.Item>
          ) : (
            <DropdownMenu.Item asChild>
              <Link href="/auth/login" className="block cursor-pointer rounded px-2 py-1.5 text-foreground hover:bg-muted">
                Sign in
              </Link>
            </DropdownMenu.Item>
          )}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
      <form ref={formRef} action="/auth/sign-out" method="post" hidden />
    </div>
  );
}
